import React from 'react';
import Header from '../components/Header';
import logo from "../assets/logo.webp"
import PrimaryButton from '../components/Buttons/PrimaryButton';
import { useNavigate } from 'react-router-dom';

function Home() {

    const navigate = useNavigate()

    return (
        <div>
            <Header />
            <div className='bg-[#f2f2f2] w-full h-[95vh]'>
                <div className="flex items-center justify-center h-[93vh] bg-gray-100">
                    <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md border">
                        <div className="flex flex-col items-center">
                            <img src={logo} alt="Logo" className="mb-4 w-[250px] h-[145px]" />
                            <h1 className="text-2xl text-[#1c2438] font-semibold mb-2">BIENVENUE À DIGIS ASSUR</h1>
                            <p className="text-[#FF8449] mb-4">Veuillez sélectionner votre choix</p>

                            <PrimaryButton label={"CONNECTEZ-VOUS"} onClick={() => {navigate("/login")}} />
                            {/* <PrimaryButton label={"CRÉEZ VOTRE COMPTE"} /> */}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
